// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  padding: 40px;
}

.justice-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
}
.justice-loader .gavel {
  font-size: 48px;
  margin-bottom: 16px;
  animation: swing 1.5s ease-in-out infinite;
  transform-origin: center top;
}
.justice-loader .gavel .gavel-img {
  width: 60px;
  height: 60px;
}
.justice-loader .loading-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
  opacity: 0.8;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes swing {
  0%, 100% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-2deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.hammer-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hammer-loader .hammer {
  font-size: 40px;
  margin-bottom: 16px;
  animation: hammer 1s ease-in-out infinite;
  transform-origin: bottom center;
}
.hammer-loader .anvil {
  font-size: 24px;
  margin-bottom: 16px;
  animation: anvil-shake 1s ease-in-out infinite;
}

@keyframes hammer {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  75% {
    transform: rotate(-45deg);
  }
}
@keyframes anvil-shake {
  0%, 100% {
    transform: translateX(0);
  }
  25%, 75% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/JusticeLoader/JusticeLoader.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,4BAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAIE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;AAFJ;;AAOA;EAEE;IAEE,uBAAA;EANF;EASA;IACE,wBAAA;EAPF;EAUA;IACE,yBAAA;EARF;EAWA;IACE,uBAAA;EATF;EAYA;IACE,wBAAA;EAVF;AACF;AAaA;EAEE;IAEE,YAAA;EAbF;EAgBA;IACE,UAAA;EAdF;AACF;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,eAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,mBAAA;EACA,8CAAA;AAjBJ;;AAqBA;EAEE;IAEE,uBAAA;EApBF;EAuBA;IACE,yBAAA;EArBF;EAwBA;IACE,yBAAA;EAtBF;EAyBA;IACE,yBAAA;EAvBF;AACF;AA0BA;EAEE;IAEE,wBAAA;EA1BF;EA6BA;IAEE,2BAAA;EA5BF;EA+BA;IACE,0BAAA;EA7BF;AACF","sourcesContent":["// Create a new file: components/JusticeLoader/JusticeLoader.scss\r\n.loading-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 300px;\r\n  width: 100%;\r\n  padding: 40px;\r\n}\r\n\r\n.justice-loader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 1rem;\r\n\r\n  .gavel {\r\n    font-size: 48px;\r\n    margin-bottom: 16px;\r\n    animation: swing 1.5s ease-in-out infinite;\r\n    transform-origin: center top;\r\n\r\n    .gavel-img {\r\n      width: 60px;\r\n      height: 60px;\r\n    }\r\n  }\r\n\r\n  .loading-text {\r\n    font-size: 16px;\r\n    color: #666;\r\n    font-weight: 500;\r\n    opacity: 0.8;\r\n    animation: pulse 2s ease-in-out infinite;\r\n  }\r\n}\r\n\r\n// Enhanced swing animation\r\n@keyframes swing {\r\n\r\n  0%,\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  20% {\r\n    transform: rotate(15deg);\r\n  }\r\n\r\n  40% {\r\n    transform: rotate(-10deg);\r\n  }\r\n\r\n  60% {\r\n    transform: rotate(5deg);\r\n  }\r\n\r\n  80% {\r\n    transform: rotate(-2deg);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n\r\n  0%,\r\n  100% {\r\n    opacity: 0.6;\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Alternative hammer-style loader if you prefer\r\n.hammer-loader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  .hammer {\r\n    font-size: 40px;\r\n    margin-bottom: 16px;\r\n    animation: hammer 1s ease-in-out infinite;\r\n    transform-origin: bottom center;\r\n  }\r\n\r\n  .anvil {\r\n    font-size: 24px;\r\n    margin-bottom: 16px;\r\n    animation: anvil-shake 1s ease-in-out infinite;\r\n  }\r\n}\r\n\r\n@keyframes hammer {\r\n\r\n  0%,\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  25% {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  50% {\r\n    transform: rotate(-90deg);\r\n  }\r\n\r\n  75% {\r\n    transform: rotate(-45deg);\r\n  }\r\n}\r\n\r\n@keyframes anvil-shake {\r\n\r\n  0%,\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  25%,\r\n  75% {\r\n    transform: translateX(-2px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateX(2px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
